import { apiClient } from "../../../lib";
import { TrendsGraphData } from "../types";

export const trendsForecast = {

    fetch: async (): Promise<TrendsGraphData> => {
        const response = await apiClient.get(`/projects/trends-forecast`);
        return response.data.data;
    },

};
